/**
 * @fileoverview PUT handler for the "/product_alerts/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { productAlertsIdCacheKeys } from "./constants";
import type { ProductAlertResultItem, PutProductAlertProps } from "./types";
import { isProductAlertResultItem } from "./validators";

export const putProductAlert = reactQueryMutationAdapter(
  productAlertsIdCacheKeys,
  async (props: PutProductAlertProps): Promise<ProductAlertResultItem> => {
    const { id, ...body } = props;
    const response = await fetch(`/product_alerts/${id}`, "PUT", body);

    if (!isProductAlertResultItem(response)) {
      throw new Error("Invalid product alert response");
    }

    return response;
  }
);
